<template>

    <div class="min-h-screen-ios min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 sm:bg-gray-300 text-regal-blue-900 pb-36">
       <div class="sm:mx-auto sm:w-full sm:max-w-screen-sm">

           <div class="bg-white w-full rounded-3xl">
               <div class="min-w-screen flex flex-col items-center justify-center p-8 space-y-4">
                   <div class="text-3xl font-bold tracking-tight w-full sm:text-center">
                       What‘s your name?
                   </div>
                   <div class="sm:text-center text-gray-800 w-full">
                       This could be your first name, or a nickname — however you’d like people to refer to you at {{ account.name }}. 👋
                   </div>
                   <form class="w-full" @submit.prevent="storeName">
                       <input type="text" name="" v-model="form.name" class="w-full h-20 p-5 text-2xl rounded-lg" autofocus>
                       <InlineError v-if="form.errors.name" :message="form.errors.name"/>
                       <button type="submit" class="hidden" name="button"></button>
                   </form>
               </div>
           </div>

       </div>
   </div>

   <OnboardingFooter :steps="steps" :form="form" />
</template>

<script>
    import { useForm } from '@inertiajs/inertia-vue3'
    import InlineError from '@/Shared/InlineError'
    import Button from '@/Shared/Button'
    import { ref } from 'vue'
    import OnboardingFooter from '@/Shared/OnboardingFooter'

    export default {
        setup(props) {
            const form = useForm({
                name: props.user.name ?? null,
            })
            return { form }
        },
        components: { Button, InlineError, OnboardingFooter },
        props: {
            user: Object,
            account: Object,
            steps: Object,
        },
    }
</script>
